import * as React from "react"
import { renderRichText } from "gatsby-source-storyblok"
import TourItineraryBrief from "./tourItineraryBrief";
import TourItineraryDetail from "./tourItineraryDetail";
import { Trans } from "../utils/lang"

const TourItinerary = ({ blok }) => {
  // console.log(blok)

  const handleDaySelect = (e) => {
    const day = e.target.value;
    if (day !== '') {
      document.getElementById(`itinerary-${day}`).scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div id="itinerary" className="pt-10">
      <div className={`container ${blok.hideItineraryMap ? 'max-w-screen-md' : 'max-w-screen-lg'} mx-auto py-10 flex flex-wrap`}>

        <div className={`w-full ${blok.hideItineraryMap ? '' : 'md:w-1/2'}`}>
          <div className="flex flex-row px-5">
            <h2 className="text-3xl font-bold">{Trans('itinerary')} </h2>
            { blok.durationDays > 1 &&
            <div className="ml-12 flex flex-row text-center">
                <div>
                  <h3 className="text-2xl font-bold">{blok.durationDays}</h3>
                  <p className="text-sm">{blok.durationDays <= 1 ? 'Day' : 'Days'}</p>
                </div>
                { blok.durationNights > 0 &&
                <>
                <div className="h-10 -skew-x-12 mx-5 border-l border-black"></div>
                <div className="">
                  <h3 className="text-2xl font-bold">{blok.durationNights}</h3>
                  <p className="text-sm">{blok.durationNights <= 1 ? 'Night' : 'Nights'}</p>
                </div>
                </>
                }
              </div>
            }
          </div>
          <div className="p-5" dangerouslySetInnerHTML={{ __html: renderRichText(blok.itineraryDescription) }}></div>

          { blok.durationDays > 1 &&
          <div className="flex flex-col bg-slate-50 mt-5 px-10 py-6">
            <span className="text-lg font-bold">Jump to Day-by-Day Details</span>
            <div className="mt-3">
              <select className="border-b border-black" onChange={handleDaySelect}>
                <option value="">Select a day</option>
                {blok.itinerary.map((item, i) => (
                  <option key={i} value={item.dayNumber}>
                    Day {item.dayNumber}
                  </option>
                ))}
              </select>
            </div>
          </div>
          }
        </div>

        {!blok.hideItineraryMap &&
        <div className="w-full md:w-1/2 flex flex-col justify-center">
          <div className="overflow-x-auto" dangerouslySetInnerHTML={{__html: blok.itineraryMap}} />
        </div>
        }
      </div>

      <TourItineraryDetail itinerary={blok.itinerary} />
    </div>
  )
};

export default TourItinerary;
